// Mapping to given a subdomain identify the IDP hint
export function getIdpHint() {
  const idpMap = {
    "internal-rmc": [{ idpHint: "internal-rellevate" }],
    "crs-rmc": [{ idpHint: "crs" }],
    "dcpa-rmc": [{ idpHint: "dcpa-rellevate" }],
    "uis-rmc-dev": [
      {
        idpHint: "uis-1-rellevate",
        name: "UofI Urbana-Champaign",
        order: 1,
      },
      {
        idpHint: "uis-2-rellevate",
        name: "UofI Chicago",
        order: 2
      },
      {
        idpHint: "uis-4-rellevate",
        name: "UofI Springfield",
        order: 3
      },
      {
        idpHint: "uis-9-rellevate",
        name: "UofI System Offices",
        order: 4
      },
    ],
    "uis-rmc": [
      {
        idpHint: "uis-1-rellevate",
        name: "UofI Urbana-Champaign",
        order: 1,
      },
      {
        idpHint: "uis-2-rellevate",
        name: "UofI Chicago",
        order: 2
      },
      {
        idpHint: "uis-4-rellevate",
        name: "UofI Springfield",
        order: 3
      }
    ],
    // "subdomain": [{ idpHint }] or [{ idpHint, name, order }, ...]
  };

  const defaultIdp = [{ idpHint: "none" }];

  const hostname = window.location.hostname;
  const subdomain = hostname.split(".")[0] || "";
  const idpConfig = idpMap[subdomain] || defaultIdp;

  // If only one IdP, return the object for backward compatibility
  if (Array.isArray(idpConfig) && idpConfig.length === 1) {
    return idpConfig[0];
  }
  return idpConfig;
}
